module.exports = __webpack_public_path__ + "io.0c878991b1aca651c7fe.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/io.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/io.svg
// module chunks = styles